<template>
    <div v-if="!loading">
        <div class="installation-of-the-month-attachments-modal-window" :class="{'open': selected_submission !== null}" @click="selected_submission = null, selected_image_index = 0"
             v-if="selected_submission !== null">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="selected_submission = null, selected_image_index = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-content">
                    <div class="selected-image">
                        <img :src="`${$aws_bucket_url}${selected_submission.attachments[selected_image_index].file_url}`">
                        <a class="download-button" @click.prevent="downloadAttachment(selected_submission.attachments[selected_image_index].id)">
                            <i class="fal fa-download"></i>
                        </a>
                    </div>
                    <div v-if="selected_submission.winner" class="title-bar">
                        {{ selected_submission.friendly_month_submitted_at }}'s Winner - {{ selected_submission.company_name }}
                    </div>
                    <div class="installation-of-the-month-attachments">
                        <div v-for="(attachment,  index) in selected_submission.attachments" class="attachment">
                            <a @click.prevent="selected_image_index = index" :style="attachmentThumbUrl(attachment)" class="image">
                                <span class="view-btn"><i class="fal fa-search"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="saving_file_number > 0">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Uploading file {{ saving_file_number }} of {{ attachments.length }}, please wait
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Saving, please wait
                </div>
            </div>
        </div>
        <div class="box mt-6">
            <div class="box-content">
                <div>
                    <div class="form-group">
                        <strong>Submitted by: {{ submission.user.company.name }} - {{ submission.user.name }} - {{ submission.user.email }} </strong>
                    </div>
                    <div class="form-group">
                        <label>Title</label>
                        <input type="text" v-model="submission.title" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" rows="6" v-model="submission.description"></textarea>
                    </div>
                    <div class="installation-of-the-month-attachments">
                        <div v-for="(attachment, index) in submission.attachments" class="attachment">
                            <div class="image" :style="attachmentThumbUrl(attachment)">
                                <span class="view-btn" @click="selected_submission = submission, selected_image_index = index"><i class="fal fa-search"></i></span>
                                <span class="delete-btn" @click="removeAttachment(attachment.id)"><i class="fal fa-trash"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group full-height flex flex-col mt-3">
                        <label>Upload Images</label>
                        <form :action="`${$aws_upload_url}`" method="post"
                              enctype="multipart/form-data" id="amazon_form">
                            <input type="hidden" name="policy" :value="aws_policy">
                            <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                            <input type="hidden" name="x-amz-credential" :value="aws_credential">
                            <input type="hidden" name="x-amz-date" :value="aws_date">
                            <input type="hidden" name="x-amz-signature" :value="aws_signature">
                            <input type="hidden" name="acl" value="private">
                        </form>
                        <vue-dropzone
                            ref="fileUploadDropzone"
                            id="dropzone"
                            :options="dropzoneOptions"
                            v-on:vdropzone-file-added="fileAddedToDropZone"
                            v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                            :useCustomSlot="true"
                        >
                            <div>
                                <div class="mb-3">
                                    DRAG AND DROP FILES
                                </div>
                                <div class="mb-3">
                                    OR
                                </div>
                                <div>
                                    <a class="btn-secondary-outline">
                                        Choose files
                                    </a>
                                </div>
                            </div>
                        </vue-dropzone>
                    </div>
                    <div class="flex">
                        <div class="form-group flex-1 pr-3">
                            <label>Company Name</label>
                            <input type="text" v-model="submission.company_name" class="form-control">
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <label>Contact Name</label>
                            <input type="text" v-model="submission.contact_name" class="form-control">
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <label>Email Address</label>
                            <input type="text" v-model="submission.email" class="form-control">
                        </div>
                        <div class="form-group flex-1">
                            <label>Tel</label>
                            <input type="text" v-model="submission.phone" class="form-control">
                        </div>
                    </div>
                    <div class="flex">
                        <div class="form-group flex-1 pr-3">
                            <label>Linkedin</label>
                            <input type="text" v-model="submission.linkedin" class="form-control">
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <label>Facebook</label>
                            <input type="text" v-model="submission.facebook" class="form-control">
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <label>X (Twitter)</label>
                            <input type="text" v-model="submission.twitter" class="form-control">
                        </div>
                        <div class="form-group flex-1">
                            <label>Instagram</label>
                            <input type="text" v-model="submission.instagram" class="form-control">
                        </div>
                    </div>
                    <div class="form-group mb-0">
                        <label>Select Systems / Colours</label>
                        <div class="flex">
                            <div class="form-group flex-1">
                                <div class="multi-select-input" @click.stop="systems_installed_dropdown_open = !systems_installed_dropdown_open">
                                    <div class="multi-select-input-placeholder">
                                        Systems Installed
                                        <div class="dropdown-icon">
                                            <i class="fal fa-chevron-down"></i>
                                        </div>
                                    </div>
                                    <div class="multi-select-input-inner" v-show="systems_installed_dropdown_open">
                                        <div class="multi-select-input-group mt-3">
                                            <h1 class="input-group-title">Select Material</h1>
                                            <div class="radios">
                                                <div class="radio level-1">
                                                    <label>
                                                        <input type="radio" name="material_type" :value="'PVC-U'" v-model="submission.material_type">
                                                        <span class="radio-label">PVC-U</span>
                                                    </label>
                                                    <label>
                                                        <input type="radio" name="material_type" :value="'Aluminium'" v-model="submission.material_type">
                                                        <span class="radio-label">Aluminium</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="multi-select-input-group">
                                            <h1 class="input-group-title">System Types</h1>
                                            <div class="checkboxes" v-if="submission.material_type === 'PVC-U'">
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Profile 22 Chamfered'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Profile 22 Chamfered</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Profile 22 Sculptured'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Profile 22 Sculptured</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Spectus Bevelled'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Spectus Bevelled</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Spectus Ovolo'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Spectus Ovolo</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Flush Casement Window'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Flush Casement Window</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Vertical Sliding Sash Window'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Vertical Sliding Sash Window</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Flush Tilt & Turn Window'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Flush Tilt & Turn Window</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Fully Reversible Window'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Fully Reversible Window</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Composite Door Outer Frame'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Composite Door Outer Frame</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Curtain Walling'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Curtain Walling</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'PatioMaster Sliding Patio Door'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">PatioMaster Sliding Patio Door</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Other'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Other</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="checkboxes" v-if="submission.material_type === 'Aluminium'">
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Stellar Aluminium Flush Casement Window'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Stellar Aluminium Flush Casement Window</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Stellar Aluminium Fully Flush Casement Window'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Stellar Aluminium Fully Flush Casement Window</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Stellar Aluminium Flush Tilt & Turn Window'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Stellar Aluminium Flush Tilt & Turn Window</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Stellar Aluminium French Flush Casement Window'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Stellar Aluminium French Flush Casement Window</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Stellar Aluminium Flush Door'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Stellar Aluminium Flush Door</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Stellar Aluminium Lift & Slide Door'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Stellar Aluminium Lift & Slide Door</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Stellar Aluminium Slimline Bifold'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Stellar Aluminium Slimline Bifold</span>
                                                    </label>
                                                </div>
                                                <div class="checkbox level-1">
                                                    <label>
                                                        <input type="checkbox" :value="'Other'" v-model="submission.selected_systems">
                                                        <span class="checkbox-label">Other</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group flex-1 pl-3" v-if="submission.material_type === 'PVC-U'">
                                <div class="multi-select-input" @click.stop="pvcu_external_colours_dropdown_open = !pvcu_external_colours_dropdown_open">
                                    <div class="multi-select-input-placeholder">
                                        External Colour
                                        <div class="dropdown-icon">
                                            <i class="fal fa-chevron-down"></i>
                                        </div>
                                    </div>
                                    <div class="multi-select-input-inner" v-show="pvcu_external_colours_dropdown_open">
                                        <div class="multi-select-input-group mt-3">
                                            <h1 class="input-group-title">Select Colour</h1>
                                            <div class="checkboxes">
                                                <div class="checkbox level-1" v-for="colour in pvcu_external_colours">
                                                    <label>
                                                        <input type="checkbox" name="selected_pvcu_external_colours" :value="colour" v-model="submission.selected_pvcu_external_colours">
                                                        <span class="checkbox-label">{{ colour }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group flex-1 pl-3" v-if="submission.material_type === 'PVC-U'">
                                <div class="multi-select-input" @click.stop="pvcu_internal_colours_dropdown_open = !pvcu_internal_colours_dropdown_open">
                                    <div class="multi-select-input-placeholder">
                                        Internal Colour
                                        <div class="dropdown-icon">
                                            <i class="fal fa-chevron-down"></i>
                                        </div>
                                    </div>
                                    <div class="multi-select-input-inner" v-show="pvcu_internal_colours_dropdown_open">
                                        <div class="multi-select-input-group mt-3">
                                            <h1 class="input-group-title">Select Colour</h1>
                                            <div class="checkboxes">
                                                <div class="checkbox level-1" v-for="colour in pvcu_internal_colours">
                                                    <label>
                                                        <input type="checkbox" name="selected_pvcu_internal_colours" :value="colour" v-model="submission.selected_pvcu_internal_colours">
                                                        <span class="checkbox-label">{{ colour }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group flex-1 pl-3" v-if="submission.material_type === 'PVC-U'">
                                <div class="multi-select-input" @click.stop="pvcu_base_colours_dropdown_open = !pvcu_base_colours_dropdown_open">
                                    <div class="multi-select-input-placeholder">
                                        Base Colour
                                        <div class="dropdown-icon">
                                            <i class="fal fa-chevron-down"></i>
                                        </div>
                                    </div>
                                    <div class="multi-select-input-inner" v-show="pvcu_base_colours_dropdown_open">
                                        <div class="multi-select-input-group mt-3">
                                            <h1 class="input-group-title">Select Colour</h1>
                                            <div class="checkboxes">
                                                <div class="checkbox level-1" v-for="colour in pvcu_base_colours">
                                                    <label>
                                                        <input type="checkbox" name="selected_pvcu_colours" :value="colour" v-model="submission.selected_pvcu_base_colours">
                                                        <span class="checkbox-label">{{ colour }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group flex-1 pl-3" v-if="submission.material_type === 'Aluminium'">
                                <div class="multi-select-input" @click.stop="aluminium_colours_dropdown_open = !aluminium_colours_dropdown_open">
                                    <div class="multi-select-input-placeholder">
                                        Colour
                                        <div class="dropdown-icon">
                                            <i class="fal fa-chevron-down"></i>
                                        </div>
                                    </div>
                                    <div class="multi-select-input-inner" v-show="aluminium_colours_dropdown_open">
                                        <div class="multi-select-input-group mt-3">
                                            <h1 class="input-group-title">Select Colour</h1>
                                            <div class="checkboxes">
                                                <div class="checkbox level-1" v-for="colour in aluminium_colours">
                                                    <label>
                                                        <input type="checkbox" name="selected_aluminium_colours" :value="colour" v-model="submission.selected_aluminium_colours">
                                                        <span class="checkbox-label">{{ colour }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="form-group flex-1 pr-3">
                            <label>Window type(s) / number installed</label>
                            <input type="text" v-model="submission.window_types" class="form-control">
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <label>Doors type(s) / number installed</label>
                            <input type="text" v-model="submission.door_types" class="form-control">
                        </div>
                        <div class="form-group flex-1">
                            <label>Hardware installed</label>
                            <input type="text" v-model="submission.hardware_installed" class="form-control">
                        </div>
                    </div>
                    <div class="flex">
                        <div class="form-group flex-1 pr-3">
                            <label>Any interesting features or points of note</label>
                            <textarea class="form-control" rows="6" v-model="submission.interesting_features"></textarea>
                        </div>

                        <div class="form-group flex-1">
                            <label>Other information</label>
                            <textarea class="form-control" rows="6" v-model="submission.other_information"></textarea>
                        </div>
                    </div>
                    <div class="align-right mt-3">
                        <a class="btn-danger mr-1" :href="'/commercial/installation-of-the-month/delete/'+submission.id">
                            Delete Entry
                        </a>
                        <div class="btn-primary" @click.stop="submit()">
                            Update Entry
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';

export default {
    components: {
        'vue-dropzone': vue2Dropzone,
    },
    props: {
        'aws_policy': {
            required: true,
        },
        'aws_credential': {
            required: true,
        },
        'aws_date': {
            required: true,
        },
        'aws_signature': {
            required: true,
        },
        logged_in_user: {
            required: true,
        },
        entry_id: {
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            saving_file_number: 0,
            submission: {},
            attachments: [],
            attachment_info: [],
            saving: false,
            dropzoneOptions: {
                url: '/',
                autoProcessQueue: false,
                uploadMultiple: true,
                addRemoveLinks: true,
            },
            selected_submission: null,
            selected_image_index: 0,
            csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            systems_installed_dropdown_open: false,
            pvcu_external_colours_dropdown_open: false,
            pvcu_internal_colours_dropdown_open: false,
            pvcu_base_colours_dropdown_open: false,
            aluminium_colours_dropdown_open: false,
            pvcu_external_colours: [
                'Agate Grey',
                'AnTeak',
                'Anthracite Grey',
                'Anthracite Grey Smooth',
                'Basalt Grey Smooth',
                'Black Brown',
                'Black Ulti-Matt',
                'Buckingham Grey',
                'Chartwell Green',
                'Claystone',
                'Cream',
                'Dark Green',
                'Dark Red',
                'Flemish Gold Smooth',
                'Hazy Grey',
                'Honey Oak Super Matt',
                'Irish Oak',
                'Kensington Grey',
                'Light Oak',
                'Pebble Grey',
                'Pyrite',
                'Rosewood',
                'Sage Smooth',
                'Silver D Smooth',
                'Slate Grey',
                'Slate Grey Finesse',
                'Steel Blue',
                'Swamp Oak',
                'White',
                'Windsor',
            ],
            pvcu_internal_colours: [
                'Agate Grey',
                'AnTeak',
                'Anthracite Grey',
                'Anthracite Grey Smooth',
                'Basalt Grey Smooth',
                'Black Brown',
                'Black Ulti-Matt',
                'Buckingham Grey',
                'Chartwell Green',
                'Claystone',
                'Cream',
                'Dark Green',
                'Dark Red',
                'Flemish Gold Smooth',
                'Hazy Grey',
                'Honey Oak Super Matt',
                'Irish Oak',
                'Kensington Grey',
                'Light Oak',
                'Pebble Grey',
                'Pyrite',
                'Rosewood',
                'Sage Smooth',
                'Silver D Smooth',
                'Slate Grey',
                'Slate Grey Finesse',
                'Steel Blue',
                'Swamp Oak',
                'White',
                'Windsor',
            ],
            pvcu_base_colours: [
                'Brown',
                'Cream',
                'Grey',
                'Tan',
                'White',
            ],
            aluminium_colours: [
                'Signal White',
                'Anthracite Grey',
                'Anthracite Grey / Signal White',
                'Jet Black',
                'Jet Black / Signal White',
                'Cream',
                'Agate Grey',
                'Slate Grey',
                'Chocolate Brown',
                'Anthracite Grey Textured',
            ],
        };
    },
    mounted() {
        this.loadEntry();
    },
    methods: {
        loadEntry() {
            axios.post('/commercial/installation-of-the-month/loadEntry', {
                'entry_id': this.entry_id,
            }).then((response) => {
                this.submission = response.data;
                this.loading = false;
            });
        },
        fileAddedToDropZone(uploadedFile) {
            const extension = uploadedFile.name.replace(/^.*\./, '');
            const original_file_name = uploadedFile.name.replace('.' + extension, '')
            .replace(/[\W_]+/g, "_")
            .toLowerCase();

            const allowed_extensions = [
                'jpg', 'jpeg', 'png', 'svg', 'gif', 'bmp',
            ];

            if (!allowed_extensions.includes(extension.toLowerCase())) {
                this.$refs.fileUploadDropzone.dropzone.removeFile(uploadedFile);
                Swal.fire({
                    title: 'Invalid File Type',
                    icon: 'error',
                    text: 'File type not allowed, please ensure the file is one of the following formats: \'jpg\', \'jpeg\', \'png\',  \'svg\', \'gif\', \'bmp\''
                });
                return;
            }

            const filename = 'commercial_installation_of_the_month_uploads/' + original_file_name + '_' + Date.now();

            const new_file = {
                file: uploadedFile,
                filename: filename + '.' + extension,
                filetype: uploadedFile.type,
                original_file_name: original_file_name,
                thumbnail_url: `thumbnails/${filename}.png`,
            };

            this.attachments.push(new_file);
            this.attachment_info.push({
                thumbnail_url: `thumbnails/${filename}.png`,
                original_file_name: original_file_name,
                filename: filename + '.' + extension,
            });
        },
        fileRemovedFromDropZone(file) {
            const extension = file.name.replace(/^.*\./, '');
            const original_file_name = file.name.replace('.' + extension, '');
            this.attachments = this.attachments.filter(attachment => attachment.original_file_name !== original_file_name);
            this.attachment_info = this.attachment_info.filter(attachment => attachment.original_file_name !== original_file_name);
        },
        async submit() {

            const validationErrors = Validate({
                title: this.submission.title,
                description: this.submission.description,
                contact_name: this.submission.contact_name,
                email: this.submission.email,
                phone: this.submission.phone,
                window_types: this.submission.window_types,
                door_types: this.submission.door_types,
                hardware_installed: this.submission.hardware_installed,
            }, {
                title: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                description: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                contact_name: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                email: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                phone: {
                    presence: {
                        allowEmpty: false,
                    },
                },
                window_types: {
                    presence: {
                        allowEmpty: false,
                        message: '- Let us know how many and what type of windows were installed (please write none if not applicable)',
                    },
                },
                door_types: {
                    presence: {
                        allowEmpty: false,
                        message: '- Let us know how many and what type of doors were installed (please write none if not applicable)',
                    },
                },
                hardware_installed: {
                    presence: {
                        allowEmpty: false,
                        message: '- Let us know which hardware was used (please write none if not applicable)',
                    },
                },
            });

            if (validationErrors) {
                Swal.fire({
                    title: 'Information missing',
                    icon: 'error',
                    html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
                });
                return;
            }

            if (this.submission.attachments.length < 1 && this.attachments.length < 1) {
                Swal.fire({
                    title: 'Photos Missing',
                    icon: 'error',
                    text: 'Please add some photos to this entry'
                });
                return;
            }

            if (this.submission.selected_systems.length < 1) {
                Swal.fire({
                    title: 'Systems Missing',
                    icon: 'error',
                    text: 'Please select which systems were used'
                });
                return;
            }

            if (this.submission.material_type === 'PVC-U') {
                if(this.submission.selected_pvcu_base_colours.length < 1) {
                    Swal.fire({
                        title: 'Base Colours Missing',
                        icon: 'error',
                        text: 'Please select which base colours were used'
                    });
                    return;
                }

                if(this.submission.selected_pvcu_external_colours.length < 1) {
                    Swal.fire({
                        title: 'External Colours Missing',
                        icon: 'error',
                        text: 'Please select which external colours were used'
                    });
                    return;
                }

                if(this.submission.selected_pvcu_internal_colours.length < 1) {
                    Swal.fire({
                        title: 'Internal Colours Missing',
                        icon: 'error',
                        text: 'Please select which internal colours were used'
                    });
                    return;
                }
            }

            if (this.submission.material_type === 'Aluminium') {
                if(this.submission.selected_aluminium_colours.length < 1) {
                    Swal.fire({
                        title: 'Colours Missing',
                        icon: 'error',
                        text: 'Please select which colours were used'
                    });
                    return;
                }
            }

            if(this.attachments.length > 0) {
                this.saving_file_number = 1;

                this.attachments.forEach((attachment, index) => {

                    let form_data = new FormData(document.querySelector('#amazon_form'));
                    form_data.append('Content-Type', attachment.filetype);
                    form_data.append('key', attachment.filename);
                    form_data.append('file', attachment.file);
                    axios({
                        method: 'post',
                        url: this.$aws_upload_url,
                        data: form_data,
                        headers: {'Content-Type': 'multipart/form-data'},
                    }).then(() => {
                        if (this.saving_file_number === this.attachments.length) {
                            this.saveEntry();
                        } else {
                            this.saving_file_number = this.saving_file_number + 1;
                        }

                    });
                });
            } else {
                this.saveEntry();
            }

        },
        saveEntry() {
            this.saving_file_number = 0;
            this.saving = true;

            axios.post('/commercial/installation-of-the-month/updateEntry', {
                'submission': this.submission,
                'attachments': this.attachment_info,
            }).then((response) => {
                this.loadEntry();
                this.attachments = [];
                this.attachment_info = [];
                this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
                this.saving = false;

                Swal.fire({
                    title: 'Installation Entry Updated',
                    icon: 'success',
                    text: 'This entry has been updated'
                });
            });
        },
        attachmentUrl(attachment) {
            return {'backgroundImage': `url('${this.$aws_bucket_url}${attachment.file_url}')`};
        },
        attachmentThumbUrl(attachment) {
            if (attachment.thumbExists) {
                return {'backgroundImage': `url('${this.$aws_bucket_url}${attachment.thumbnail_url}')`};
            }
            return this.attachmentUrl(attachment);
        },
        downloadAttachment(attachment_id) {
            axios.post('/commercial/installation-of-the-month/download-attachment', {
                attachment_id: attachment_id,
            }).then((response) => {
                window.location.href = response.data;
            });
        },
        removeAttachment(attachment_id) {
            if(this.submission.attachments.length > 1) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "Are you sure you want to remove this attachment? This action cannot be undone.",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.saving = true;
                        axios.post('/commercial/installation-of-the-month/remove-attachment', {
                            attachment_id: attachment_id,
                        }).then((response) => {
                            this.saving = false;
                            Swal.fire('Attachment Deleted');
                            this.submission.attachments = this.submission.attachments.filter(function(attachment) {
                                return attachment.id !== attachment_id;
                            });
                        });
                    }
                });
            } else {
                Swal.fire({
                    title: 'Attachment not deleted',
                    text: 'You cannot remove the last attachment, please upload new images first.',
                    icon: 'error',
                });
            }

        },
    },
}
</script>
